(() => {
  // Solo /cart
  if (!document.body.classList.contains('template-cart') && !location.pathname.includes('/cart')) return;

  const input = document.getElementById('CartDiscountCode');
  const applyBtn = document.getElementById('CartDiscountApply');
  const removeBtn = document.getElementById('CartDiscountRemove');
  const msg = document.getElementById('CartDiscountMsg');

  if (!input || !applyBtn || !removeBtn) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  const updateUrl = `${root}cart/update.js`;

  const setBusy = (busy) => {
    input.disabled = busy;
    applyBtn.disabled = busy;
    removeBtn.disabled = busy;
  };

  const show = (t) => { if (msg) msg.textContent = t || ''; };

  async function postDiscount(code) {
    const res = await fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
    if (!res.ok) throw new Error(`Cart update failed: ${res.status}`);
    return res.json();
  }

  async function applyDiscount() {
    const code = (input.value || '').trim();
    if (!code) return show('Escribe un cupón.');

    setBusy(true);
    show('Aplicando...');
    try {
      await postDiscount(code);
      // Recarga /cart para ver el total ya rebajado y que tus reglas/regalos se recalculen aquí (antes de checkout)
      location.reload();
    } catch (e) {
      console.error(e);
      show('No se pudo aplicar el cupón. Revisa el código.');
      setBusy(false);
    }
  }

  async function removeDiscount() {
    setBusy(true);
    show('Quitando cupón...');
    try {
      await postDiscount('');
      location.reload();
    } catch (e) {
      console.error(e);
      show('No se pudo quitar el cupón.');
      setBusy(false);
    }
  }

  applyBtn.addEventListener('click', applyDiscount);

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      applyDiscount();
    }
  });

  removeBtn.addEventListener('click', removeDiscount);
})();
